import { useEffect } from 'react';

import { ADS_PUB_ID } from '@/lib/constants';

interface Props {
  slotId: string;
  format?: string;
  mt?: string;
  mb?: string;
}

const AdSlot = ({ slotId, format = 'auto', mt = '2rem', mb = '0' }: Props) => {
  useEffect(() => {
    ((window as any).adsbygoogle = (window as any).adsbygoogle || []).push({});
  }, []);

  return (
    <div>
      <ins
        className="adsbygoogle"
        style={{
          display: 'block',
          marginTop: mt,
          marginBottom: mb,
        }}
        data-ad-format={format}
        data-full-width-responsive="true"
        data-ad-client={`${ADS_PUB_ID}`}
        data-ad-slot={slotId}
      />
    </div>
  );
};

export { AdSlot };
